import { render, staticRenderFns } from "./bh-flow-field-generator.vue?vue&type=template&id=7df8b831&lang=pug"
import script from "./bh-flow-field-generator.vue?vue&type=script&lang=ts"
export * from "./bh-flow-field-generator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCombobox,VTextField,VTextarea})
